import state from './moduleNurseState.js';
import mutations from './moduleNurseMutations.js';
import actions from './moduleNurseActions.js';
import getters from './moduleNurseGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
